'use strict';
exports.__esModule = true;
function promiseAllSettled(promises) {
  return Promise.all(
    promises.map(function (promise) {
      return Promise.resolve()
        .then(function () {
          return promise;
        })
        .then(function (value) {
          return {
            value: value,
            status: 'fulfilled',
          };
        })
        ['catch'](function (reason) {
          return {
            reason: reason,
            status: 'rejected',
          };
        });
    }),
  );
}
Promise.allSettled = promiseAllSettled;
exports['default'] = promiseAllSettled;
